<template>
  <v-container fluid style="height: 100vh; width: 100vm" class="pa-0">
    <v-navigation-drawer
      app
      right
      enable-resize-watcher
      :stateless="!$vuetify.breakpoint.smAndDown"
      v-model="mapSideDrawer"
      class="elevation-4"
      :width="(logbook !== null || refueling !== null || events !== null || plans !== null || contracts !== null) ? 600 : ((vehicle !== null || history !== null) ? 500 : 340)"
      style="z-index: 3000"
    >
      <SideHistory v-if="history !== null"
                   @clicked="rideSidebarClicked" />
      <SideLogbook v-else-if="logbook !== null"
                   @clicked="rideSidebarClicked" />
      <SideRefueling v-else-if="refueling !== null"
                     @clicked="rideSidebarClicked" />
      <SideEvents v-else-if="events !== null"
                  @clicked="rideSidebarClicked" />
      <SideContracts v-else-if="contracts !== null"
                     @clicked="rideSidebarClicked" />
      <SideService v-else-if="plans !== null"
                     @clicked="rideSidebarClicked" />
      <SideVehicle v-else-if="vehicle !== null"
                   @clicked="rideSidebarClicked" />
      <SideOnline v-else-if="$store.state.online.mapMode === 'online'"
                  @clicked="vehicleSidebarClicked"
                  v-on:action-vehicle="onVehicleActionVehicle"
                  v-on:action-history="onVehicleActionHistory"
                  v-on:action-logbook="onVehicleActionLogbook"
                  v-on:action-refueling="onVehicleActionRefueling"
                  v-on:action-events="onVehicleActionEvents"
                  v-on:action-contracts="onVehicleActionContracts"
                  v-on:action-service="onVehicleActionService"
                  v-on:action-visibility="onVehicleActionVisibility"
                  v-on:show-filtered="onOnlineShowFiltered"
                  v-on:hide-filtered="onOnlineHideFiltered"
      />
    </v-navigation-drawer>

    <BottomLayout style="width: 100%; height: 100%">
      <l-map
        :key="renderMapKey"
        :center="center"
        :zoom="zoom"
        class="map"
        ref="map"
        style="'z-index: 0"
        @ready="mapReady()"
        :options="mapOptions">
        <l-tile-layer
          :url="mapLayer.url"
          :attribution="mapLayer.attribution"
        />
        <GoogleLayer v-if="mapLayer.google"
                     :type="mapLayer.type"
                     :layer="mapLayer.layer"
        />

        <l-control position="topright">
          <v-tooltip style="z-index: 4000" bottom open-delay="500">
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                x-small
                color="white"
                elevation="2"
                v-on:click="toggleSidebar()"
                v-on="on"
              >
                <v-icon v-if="mapSideDrawer">mdi-chevron-double-right</v-icon>
                <v-icon v-else>mdi-chevron-double-left</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.tooltip.right_panel") }}</span>
          </v-tooltip>
        </l-control>

        <l-control position="topright">
          <v-menu offset-y z-index="4000">
            <template v-slot:activator="{ on: menu, attrs }">
              <v-tooltip style="z-index: 4000" bottom open-delay="500">
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    fab
                    x-small
                    color="white"
                    elevation="2"
                    v-bind="attrs"
                    v-on="{ ...tooltip, ...menu }"
                  >
                    <v-icon>mdi-map</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("map.tooltip.map_layer") }}</span>
              </v-tooltip>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in this.maps"
                :key="index"
                link
                @click="changeLayer(item)"
              >
                <v-list-item-title>{{ $t(item.title_i18n, { name: item.title }) }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </l-control>

        <l-control position="topright" v-if="refreshVisible">
          <v-tooltip style="z-index: 4000" bottom open-delay="500">
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                x-small
                :disabled="!refreshEnabled"
                color="white"
                elevation="2"
                v-on:click="actionRefresh()"
                v-on="on"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.tooltip.refresh") }}</span>
          </v-tooltip>
        </l-control>

        <l-control position="topleft">
          <v-menu z-index="4000" open-on-hover>
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                fab
                x-small
                color="orange"
                elevation="2"
                v-bind="attrs"
                v-on="{ ...menu }"
              >
                <span
                  style="font-weight: bold; font-size: 20px; color: white; -webkit-text-stroke: 1px #ffc979; ">S</span>
              </v-btn>
            </template>
            <v-card>
              <MainMenu />
            </v-card>
          </v-menu>
        </l-control>

        <l-control position="topleft">
          <v-item-group class="v-btn-group-vertical">
            <v-tooltip style="z-index: 4000" bottom open-delay="500">
              <template v-slot:activator="{ on }">
                <v-btn
                  elevation="2"
                  color="white"
                  x-small
                  width="26px"
                  height="30px"
                  class="map-button"
                  v-on:click="zoomIn()"
                  v-on="on"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("map.tooltip.zoom_in") }}</span>
            </v-tooltip>

            <v-tooltip style="z-index: 9999" bottom open-delay="500">
              <template v-slot:activator="{ on }">
                <v-btn
                  elevation="2"
                  color="white"
                  x-small
                  width="26px"
                  height="30px"
                  class="map-button"
                  v-on:click="zoomOut()"
                  v-on="on"
                >
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("map.tooltip.zoom_out") }}</span>
            </v-tooltip>

            <v-tooltip style="z-index: 9999" bottom open-delay="500">
              <template v-slot:activator="{ on }">
                <v-btn
                  x-small
                  elevation="2"
                  color="white"
                  width="26px"
                  height="30px"
                  v-on:click="defaultMapView()"
                  v-on="on"
                >
                  <v-icon dense>check_box_outline_blank</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("map.tooltip.default_view") }}</span>
            </v-tooltip>
          </v-item-group>
        </l-control>

        <IconProperties v-if="vehiclePopup.vehicle != null"
                        ref="vehiclePopupComponent"
                        :title="vehiclePopup.vehicle.numericPlate"
                        :subtitle="vehiclePopup.vehicle.name"
                        :items="vehiclePopup.info"
                        :actions="vehiclePopup.actions"
                        v-on:action="vehicleActionHandler"
                        style="min-width: 280px">
          <template v-slot:person-tachograph>
            <template v-if="vehiclePopup.tachograph.dataValidity">
              <v-row no-gutters class="flex-nowrap">
                <v-col>
                  <v-icon small style="padding-bottom: 2px">
                    {{ tachographActivityIcon(vehiclePopup.tachograph.activity) }}
                  </v-icon>&nbsp;
                  {{ $t("enum.tachograph_activity." + vehiclePopup.tachograph.activity) }}
                </v-col>
                <v-col class="text-right ml-2">
                  <v-tooltip style="z-index: 9999" bottom open-delay="500">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" x-small elevation="0"
                             style="height: 16px; padding: 4px 8px; margin-bottom: 2px"
                             @click="reportTachograph" v-on="on">
                        {{ $t("map.panel.vehicle.tachograph.history") }}
                      </v-btn>
                    </template>
                    <span>{{ $t("map.panel.vehicle.tachograph.history_tooltip") }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-tooltip style="z-index: 9999" bottom open-delay="500">
                <template v-slot:activator="{ on }">
                  <v-progress-linear
                    :value="calcPrecent(vehiclePopup.tachograph.dayDriveAccumulation, vehiclePopup.tachograph.dayDriveLimit)"
                    height="18"
                    rounded
                    color="orange"
                    v-on="on"
                  >
                    {{ formatDuration(vehiclePopup.tachograph.dayDriveAccumulation) }}
                    <span class="grey--text text--darken-1">&nbsp;•&nbsp;{{ $t("common.remaining") }}&nbsp;</span>
                    {{ formatDuration(vehiclePopup.tachograph.dayDriveLimit - vehiclePopup.tachograph.dayDriveAccumulation)
                    }}
                  </v-progress-linear>
                </template>
                <span>{{ $t("map.tooltip.vehicle_popup.tachograph_day") }}</span>
              </v-tooltip>

              <div style="height: 3px"></div>

              <v-tooltip style="z-index: 9999" bottom open-delay="500">
                <template v-slot:activator="{ on }">
                  <v-progress-linear
                    :value="calcPrecent(vehiclePopup.tachograph.weekDriveAccumulation, vehiclePopup.tachograph.weekDriveLimit)"
                    height="18"
                    rounded
                    color="blue"
                    v-on="on"
                  >
                    {{ formatDuration(vehiclePopup.tachograph.weekDriveAccumulation) }}
                    <span class="grey--text text--darken-1">&nbsp;•&nbsp;{{ $t("common.remaining") }}&nbsp;</span>
                    {{ formatDuration(vehiclePopup.tachograph.weekDriveLimit - vehiclePopup.tachograph.weekDriveAccumulation)
                    }}
                  </v-progress-linear>
                </template>
                <span>{{ $t("map.tooltip.vehicle_popup.tachograph_week") }}</span>
              </v-tooltip>
            </template>
            <template v-else>
            <span class="font-weight-bold orange--text">{{ $t("map.tooltip.vehicle_popup.invalid_tachograph_data")
              }}</span>
            </template>
          </template>

          <template v-slot:ride-info>
            {{ $t("enum.ride_type." + vehiclePopup.vehicle.ride.rideType) }}
            <template v-if="vehiclePopup.vehicle.ride.driverQuality !== null">
              &nbsp;<span style="color: gray;">|</span>&nbsp;
              <v-icon small>workspace_premium</v-icon>
              <span :class="[classQuality(vehiclePopup.vehicle.ride.driverQuality), 'font-weight-bold']"
                    style="padding-left: 4px">{{ formatQuality(vehiclePopup.vehicle.ride.driverQuality) }}</span>
            </template>
          </template>

          <template v-slot:tank-info
                    v-if="vehiclePopup.vehicle.ride.tankSum !== null && vehiclePopup.vehicle.tankCapacity !== null">
            <v-progress-linear
              :value="calcPrecent(vehiclePopup.vehicle.ride.tankSum, vehiclePopup.vehicle.tankCapacity)"
              height="18"
              rounded
              color="green"
            >
              {{ vehiclePopup.vehicle.ride.tankSum + " l" }}
            </v-progress-linear>
          </template>

        </IconProperties>
      </l-map>

      <template v-slot:bottom v-if="history !== null">
        <HistoryControl
          v-on:graph-visible="refreshMapControl()"
          v-on:location="showHistoryLocationPopup"
        />
      </template>
    </BottomLayout>

    <CompanySelectionDialog ref="companySelectionDialog" />
  </v-container>
</template>

<script>
import DockLayout from "@/components/DockLayout";
import GoogleLayer from "@/components/map/GoogleLayer";
import CompanySelectionDialog from "@/components/dialogs/CompanySelectionDialog";
import SideOnline from "@/components/map/SideOnline";
import SideHistory from "@/components/map/SideHistory";
import SideLogbook from "@/components/map/SideLogbook";
import SideRefueling from "@/components/map/SideRefueling";
import SideVehicle from "@/components/map/SideVehicle";
import HistoryControl from "@/components/map/HistoryControl";
import IconProperties from "@/components/map/IconProperties";
import L from "leaflet";
import maputils from "@/maputils";
import utils from "@/utils";
import MainMenu from "@/components/MainMenu";
import { DateTime } from "luxon";
import SideEvents from "@/components/map/SideEvents.vue";
import SideContracts from "@/components/map/SideContracts.vue";
import SideService from "@/components/map/SideService.vue";

//const COLOR_MAP_ITEM_NORMAL = "#3f7dff";
//const COLOR_MAP_ITEM_SELECTED = "#fb3385";
//const COLOR_MAP_ITEM_HOVER = "#ff80b1";

export default {
  name: "MapView",

  components: {
    SideService,
    SideContracts,
    SideEvents,
    MainMenu,
    BottomLayout: DockLayout,
    HistoryControl,
    SideOnline,
    SideHistory,
    SideLogbook,
    SideRefueling,
    SideVehicle,
    GoogleLayer,
    CompanySelectionDialog,
    IconProperties
  },

  data() {
    return {
      renderMapKey: 0,
      mapSideDrawer: false,
      center: [49.0414010, 13.0698517],
      zoom: 5,
      rotation: 0,
      selectedFeatures: [],
      map: null,
      vehicleFilter: null,
      mapOptions: {
        zoomControl: false
      },
      maps: maputils.MAP_LAYRES.filter(x => x.enabled),
      /**
       * Kam se ma zazoomovat následující zoomToFeatures.
       */
      zoomToFeaturesTimer: null,
      mapLayer: maputils.MAP_LAYRES[0],
      dialogCompanySelectionVisible: false,
      /**
       * Mapová vrstva z historii vybareného vozidla
       */
      historyLayer: null,
      /**
       * Parametry vrstvy z historii vybareného vozidla
       */
      historyOptions: {
        onEachFeature: this.onEachFeature,
        pointToLayer: this.pointToLayer,
        style: this.historySelectedStyle
      },
      /**
       * Mapová vrstva s knihou jízd vybraného vozidla
       */
      logbookLayer: null,
      /**
       * Parametry vrstvy s knihou jízd vybraného vozidla
       */
      logbookOptions: {
        onEachFeature: this.onEachFeature,
        pointToLayer: this.pointToLayer,
        style: this.historySelectedStyle
      },
      /**
       * Mapová vrstva s tankováním vybraného vozidla
       */
      refuelingLayer: null,
      /**
       * Parametry vrstvy z tankováním vybraného vozidla
       */
      refuelingOptions: {
        onEachFeature: this.onEachFeature,
        pointToLayer: this.pointToLayer,
        style: this.historySelectedStyle
      },
      /**
       * Mapová vrstva s událostmi vybareného vozidla
       */
      eventsLayer: null,
      /**
       * Parametry vrstvy s událostmi vybraného vozidla
       */
      eventsOptions: {
        onEachFeature: this.onEachFeature,
        pointToLayer: this.pointToLayer,
        style: this.historySelectedStyle
      },
      /**
       * Mapová vrstva s vybranou zakázkou vozidla
       */
      contractLayer: null,
      /**
       * Parametry vrstvy s vybranou zakázkou vozidla
       */
      contractOptions: {
        //onEachFeature: this.onEachFeature,
        pointToLayer: this.planPointToLayer,
        style: this.historyStyle
      },
      /**
       * Mapová vrstva zobrazeni jednoho vozdila
       */
      vehicleLayer: null,

      /**
       * Mapová vrstva z online stavem vozidel
       */
      onlineLayer: null,
      /**
       * Pokud je TRUE, po načtení vozidel ze zoomne na vybraná vozidla
       */
      onlineZoom: true,
      /**
       * Informace o vozidle na pro které se zobrazuje popup (Vehicle struktura s API)
       */
      vehiclePopup: {
        vehicle: null,
        popup: null,
        info: [
          // pozice
          {
            visible: true,
            icon: "mdi-map-marker",
            tooltip: this.$t("common.position"),
            blocks: [
              {
                flag: undefined,
                text: ""
              },
              {
                text: "",
                subtitle: true
              }
            ]
          },
          // poslědní komunikace
          {
            visible: true,
            icon: "mdi-clock-outline",
            tooltip: this.$t("common.last_timestamp"),
            blocks: [
              {
                text: ""
              },
              {
                text: "",
                subtitle: true
              }
            ]
          },
          // řidič
          {
            visible: false,
            icon: "mdi-account",
            tooltip: this.$t("common.driver"),
            blocks: [
              {
                text: "",
                visible: true
              },
              {
                slot: "person-tachograph"
              }
            ]
          },
          // info o jízdě
          {
            visible: false,
            icon: "mdi-car-info",
            tooltip: this.$t("common.ride"),
            blocks: [
              {
                slot: "ride-info"
              },
              {
                text: "",
                subtitle: true
              },
              {
                slot: "tank-info"
              }
            ]
          },
          // interní data
          {
            visible: false,
            icon: "mdi-pound-box",
            text: "",
            tooltip: this.$t("common.vehicle_ids"),
            blocks: [
              {
                text: ""
              },
              {
                text: "",
                subtitle: true,
                action: "vehicle-log"
              }
            ]
          }
        ],
        actions: [
          { icon: "mdi-crosshairs-gps", text: this.$t("common.vehicle.vehicle"), action: "vehicle" },
          { icon: "mdi-history", text: this.$t("common.vehicle.history"), action: "history" },
          { icon: "mdi-text-box-outline", text: this.$t("common.vehicle.logbook"), action: "logbook" },
          { icon: "local_gas_station", text: this.$t("common.vehicle.refueling"), action: "refueling" }
        ],
        tachograph: null
      }
    };
  },

  methods: {
    mapReady() {
      this.map = this.$refs.map.mapObject;
      this.map.attributionControl.setPrefix("Sokol");

      // pridej
      var corners = this.map._controlCorners,
        l = "leaflet-",
        container = this.map._controlContainer;

      function createCorner(vSide, hSide) {
        var className = l + vSide + " " + l + hSide;

        corners[vSide + hSide] = L.DomUtil.create("div", className, container);
      }

      createCorner("vcenter", "left");
      createCorner("vcenter", "right");
      createCorner("hcenter", "top");
      createCorner("hcenter", "bottom");

      this.onlineZoom = false;
      if (this.$store.state.online.filteredVehicles !== null && this.onlineLayer === null)
        this.refreshMapVehicles();

      if (!this.$vuetify.breakpoint.smAndDown) {
        this.$nextTick().then(() => {
          setTimeout(() => {
            this.mapSideDrawer = true;
          }, 1);
        });
      }
    },

    refreshMapControl() {
      this.$nextTick().then(() => {
        this.map.invalidateSize(false);
        this.$nextTick().then(() => {
          this.map.invalidateSize(true);
        });
      });
    },

    reportTachograph() {
      if (this.vehiclePopup.vehicle.ride !== null && this.vehiclePopup.vehicle.ride.driver !== null) {
        let personId = this.vehiclePopup.vehicle.ride.driver.personId;
        this.$router.push({
          name: "report/tachograph",
          params: { ccode: this.$store.state.auth.company.code },
          query: { "personId": personId, "periodName": "month-current" }
        });
      }
    },

    formatDuration(value) {
      if (value >= 0)
        return utils.formatHours(value);
      else
        return utils.formatHours(0);
    },

    calcPrecent(value, max) {
      return value / (max / 100);
    },

    tachographActivityIcon(activity) {
      return utils.tachographActivityIcon(activity);
    },

    formatQuality(value) {
      return utils.numberToString(value, 1, true);
    },

    classQuality(value) {
      return utils.colorClassQuality(value);
    },

    vehicleSidebarClicked(item) {
      this.centerVehicle(item);
    },

    onVehicleActionVehicle(vehicle) {
      this.$router.push({
        name: "map/vehicle",
        params: { ccode: this.$store.state.auth.company.code, id: vehicle.vehicleId }
      });
    },

    onVehicleActionHistory(vehicle) {
      this.$router.push({
        name: "map/history",
        params: { ccode: this.$store.state.auth.company.code, id: vehicle.vehicleId }
      });
    },

    onVehicleActionLogbook(vehicle) {
      this.$router.push({
        name: "map/logbook",
        params: { ccode: this.$store.state.auth.company.code, id: vehicle.vehicleId }
      });
    },

    onVehicleActionRefueling(vehicle) {
      this.$router.push({
        name: "map/refueling",
        params: { ccode: this.$store.state.auth.company.code, id: vehicle.vehicleId }
      });
    },

    onVehicleActionEvents(vehicle) {
      this.$router.push({
        name: "map/events",
        params: { ccode: this.$store.state.auth.company.code, id: vehicle.vehicleId }
      });
    },

    onVehicleActionContracts(vehicle) {
      this.$router.push({
        name: "map/contracts",
        params: { ccode: this.$store.state.auth.company.code, id: vehicle.vehicleId }
      });
    },

    onVehicleActionService(vehicle) {
      this.$router.push({
        name: "map/service",
        params: { ccode: this.$store.state.auth.company.code, id: vehicle.vehicleId }
      });
    },

    onVehicleActionVisibility(vehicle) {
      this.$store.dispatch("online/toggleVehicle", vehicle);
    },

    onOnlineShowFiltered() {
      this.$store.dispatch("online/showAllFilteredVehicles");
    },

    onOnlineHideFiltered() {
      this.$store.dispatch("online/hideAllFilteredVehicles");
    },

    actionRefresh() {
      this.$store.dispatch("online/refresh");
      this.$refs.map.$el.focus();
    },

    rideSidebarClicked() {
      if (this.$vuetify.breakpoint.smAndDown)
        this.mapSideDrawer = false;
    },

    zoomIn() {
      this.map.zoomIn();
      this.$refs.map.$el.focus();
    },

    zoomOut() {
      this.map.zoomOut();
      this.$refs.map.$el.focus();
    },

    toggleSidebar() {
      this.mapSideDrawer = !this.mapSideDrawer;
      this.$refs.map.$el.focus();
    },

    defaultMapView() {
      this.zoomToFeatures();
      if (this.history !== null && this.logbook !== null && this.refueling !== null)
        this.zoomToFeatures();
      else {
        this.zoomToFeatures();
      }

      this.$refs.map.$el.focus();
    },

    changeLayer(layer) {
      this.mapLayer = layer;
    },

    speedColor(speed, max = 255) {
      let value = 100 - speed;

      if (value < 0)
        value = 0;

      let color = 70 + value * 2;
      if (color > max)
        return max;
      else
        return color;
    },

    /*
     * Funkce stylu čáru jízdy podle rychlosti (zvýrazněná)
     */
    historySelectedStyle(feature) {
      if (feature.properties.type === "L") {
        return {
          weight: 5,
          color: "#33" + this.speedColor(feature.properties.speed).toString(16).padStart(2, "0") + "ff"
        };
      }
    },

    /*
     * Funkce stylu čáru jízdy podle rychlosti (potlačená)
     */
    historyStyle(feature) {
      if (feature.properties.type === "L") {
        const color = this.speedColor(feature.properties.speed, 200).toString(16).padStart(2, "0");

        return {
          weight: 5,
          color: "#" + color + color + "70"
        };
      } else if (feature.properties.type === "P") {
        return {
          weight: 10,
          color: "#fb1def"
        };
      }
    },

    // eslint-disable-next-line no-unused-vars
    onEachFeature(feature, layer) {
    },

    featureIcon(feature, inactive) {
      let icon_name;
      let tankChange = false;

      if (feature.properties.splitBy === "country")
        icon_name = "multiple_stop";
      else
        switch (feature.properties.rideType) {
          case "bussines":
            icon_name = "start";
            break;
          case "private":
            icon_name = "person";
            break;
          case "refueling":
          case "fuelloss":
            icon_name = "local_gas_station";
            tankChange = (feature.properties.tankDiff !== null);
            break;
          case "unloading":
          case "loading":
          case "un-loading":
            icon_name = "local_shipping";
            break;
          case "stop":
            icon_name = "sports_score";
            break;
          case "actual":
            icon_name = "my_location";
            break;
          case "parking":
            icon_name = "local_parking";
            break;
          default:
            icon_name = "place";
            break;
        }

      const timestamp = (feature.properties.timestamp !== undefined && feature.properties.timestamp !== null)
        ? DateTime.fromISO(feature.properties.timestamp).toFormat("HH:mm")
        : "";
      const amount = (tankChange)
        ? utils.formatFuel(feature.properties.tankDiff)
        : (feature.properties.distance !== undefined && feature.properties.distance !== null)
          ? utils.formatDistance(feature.properties.distance)
          : "";
      const order = (feature.properties.order !== undefined && feature.properties.order !== null)
        ? `<span class="location-marker-order">${feature.properties.order}</span>`
        : "";

      return L.divIcon({
        className: (inactive) ? "location-marker location-deselected" : "location-marker",
        html: `
<div class="location-marker-wrapper">
  <div class="location-marker-content">
    <table>
      <tr>
        <td rowSpan="2"><span class="material-icons">${icon_name}</span></td>
        <td><b>${timestamp}</b>${order}</td>
      </tr>
      <tr>
        <td>${amount}</td>
      </tr>
    </table>
  </div>
  <div class="location-marker-tip-container">
    <div class="location-marker-tip">
    </div>
  </div>
</div>`,
        iconSize: null
      });
    },

    featurePlan(feature) {
      const text = feature.properties.text;

      return L.divIcon({
        className: "plan-marker",
        html: `
<div class="plan-marker-wrapper">
  <div class="plan-marker-tip-container">
    <div class="plan-marker-tip">
    </div>
  </div>
  <div class="plan-marker-content">
        ${text}
  </div>
</div>`,
        iconSize: null
      });
    },

    pointToLayer(feature, latlng) {
      const marker = L.marker(latlng, { icon: this.featureIcon(feature, false) });
      feature.marker = marker;
      return marker;
    },

    planPointToLayer(feature, latlng) {
      if (feature.properties.text !== null) {
        const marker = L.marker(latlng, { icon: this.featurePlan(feature) });
        feature.marker = marker;
        return marker;
      } else
        return null;
    },

    zoomToFeatures(ms = 300) {
      if (this.zoomToFeaturesTimer !== null)
        return;

      this.zoomToFeaturesTimer = setTimeout(() => {
        var group = new L.featureGroup();

        this.map.eachLayer(function(layer) {
          if (layer.feature !== undefined || layer._latlng !== undefined)
            group.addLayer(layer);
        });

        if (group.getLayers().length > 0)
          this.map.fitBounds(group.getBounds(), { padding: [40, 40] });

        this.zoomToFeaturesTimer = null;
      }, ms);
    },

    vehiclePopupClick(e) {
      this.vehiclePopupShow(e.target, e.latlng);
    },

    /**
     * Volá se po kliknutí na online vozidlo mapy
     * @param feature Informace o objektu
     * @param latlng umisteni
     */
    vehiclePopupShow(feature, latlng) {
      let vehicle = feature.options.data;
      this.vehiclePopup.vehicle = vehicle;

      // nastav zobrazovaná data o vozidle
      this.vehiclePopup.info[4].visible = this.$store.state.auth.token.superuser;
      this.vehiclePopup.info[4].blocks[0].text = vehicle.vehicleId.toString();
      if (vehicle.device !== null) {
        this.vehiclePopup.info[4].blocks[1].text = vehicle.device.serialNumber;
        this.vehiclePopup.info[4].blocks[1].visible = true;
      } else
        this.vehiclePopup.info[4].blocks[1].visible = false;

      if (vehicle.location !== null) {
        this.vehiclePopup.info[0].blocks[0].flag = vehicle.location.place.countryCode;
        this.vehiclePopup.info[0].blocks[0].text = utils.formatLocation(vehicle.location.place);
        if (vehicle.location.place !== null && vehicle.location.place.name != null) {
          this.vehiclePopup.info[0].blocks[1].text = vehicle.location.place.name;
          this.vehiclePopup.info[0].blocks[1].visible = true;
        } else
          this.vehiclePopup.info[0].blocks[1].visible = false;

        this.vehiclePopup.info[1].blocks[0].text = DateTime.fromISO(vehicle.location.timestamp).toLocaleString(DateTime.DATETIME_SHORT);
        this.vehiclePopup.info[1].blocks[1].text =
          DateTime.fromISO(vehicle.location.timestamp).toRelative(DateTime.now());
      }

      if (vehicle.ride !== null) {
        this.vehiclePopup.info[3].visible = true;
        this.vehiclePopup.info[3].blocks[1].text = this.$t("enum.ride_state." + vehicle.ride.rideState);
        if (vehicle.ride.rideState === "unfinished")
          this.vehiclePopup.info[3].blocks[1].text += " (" + DateTime.fromISO(vehicle.ride.toTimestamp).toRelative(vehicle.ride.fromTimestamp) + ")";
        else if (vehicle.ride.rideState === "finished")
          this.vehiclePopup.info[3].blocks[1].text += " (" + DateTime.fromISO(vehicle.ride.toTimestamp).toRelative() + ")";

        // zobraz řidiče
        if (vehicle.ride.driver !== null || (vehicle.ride.driverCode !== null && vehicle.ride.driverIdentification !== null)) {
          this.vehiclePopup.info[2].visible = true;

          if (vehicle.ride.driver !== null)
            this.vehiclePopup.info[2].blocks[0].text = vehicle.ride.driver.firstName + " " + vehicle.ride.driver.lastName;
          else if (vehicle.ride.driverIdentification !== null) {
            this.vehiclePopup.info[2].blocks[0].text = vehicle.ride.driverCode
              + " (" + this.$t("enum.person_type_ids." + vehicle.ride.driverIdentification) + ")";
          }

          if (vehicle.ride.driver !== null && vehicle.ride.driver.tachograph !== null) {
            this.vehiclePopup.info[2].blocks[1].visible = true;
            this.vehiclePopup.tachograph = vehicle.ride.driver.tachograph;
          } else
            this.vehiclePopup.info[2].blocks[1].visible = false;
        } else
          this.vehiclePopup.info[2].visible = false;

      } else {
        this.vehiclePopup.info[2].visible = false;
        this.vehiclePopup.info[3].visible = false;
      }

      // zobraz popup
      let vehiclePopup = this.vehiclePopup;

      this.$nextTick().then(() => {
        if (vehiclePopup.popup !== null)
          vehiclePopup.popup
            .setLatLng(latlng)
            .setContent(() => this.$refs.vehiclePopupComponent.$el);
        else
          vehiclePopup.popup = L.popup()
            .setLatLng(latlng)
            .setContent(() => this.$refs.vehiclePopupComponent.$el)
            .on("remove", () => {
              vehiclePopup.popup = null;
            })
            .openOn(this.map);
      });
    },

    vehicleActionHandler(action) {
      if (action === "vehicle")
        this.$router.push({
          name: "map/vehicle",
          params: { ccode: this.$store.state.auth.company.code, id: this.vehiclePopup.vehicle.vehicleId }
        });
      else if (action === "history")
        this.$router.push({
          name: "map/history",
          params: { ccode: this.$store.state.auth.company.code, id: this.vehiclePopup.vehicle.vehicleId }
        });
      else if (action === "logbook")
        this.$router.push({
          name: "map/logbook",
          params: { ccode: this.$store.state.auth.company.code, id: this.vehiclePopup.vehicle.vehicleId }
        });
      else if (action === "refueling")
        this.$router.push({
          name: "map/refueling",
          params: { ccode: this.$store.state.auth.company.code, id: this.vehiclePopup.vehicle.vehicleId }
        });

      else if (action === "vehicle-log") {
        this.map.closePopup();
        this.$store.dispatch("dialogs/showDialog", {
          dialog: "vehicleLog",
          options: { vehicle: this.vehiclePopup.vehicle }
        });
      }
    },

    centerVehicle(item) {
      if (item.location !== null && item.location !== undefined) {
        this.map.setView([item.location.latitude, item.location.longitude], 16);
      }

      if (this.$vuetify.breakpoint.smAndDown)
        this.mapSideDrawer = false;
    },

    showOnline() {
      this.$store.dispatch("online/mapMode", "online");
    },

    showVehicle(item) {
      this.$store.dispatch("online/mapMode", "vehicle");
      this.map.closePopup();

      this.$store.dispatch("online/setVehicle", item.vehicleId);

      if (item.location !== null && item.location !== undefined) {
        this.map.setView([item.location.latitude, item.location.longitude], 16);
      }

      if (this.$vuetify.breakpoint.smAndDown)
        this.mapSideDrawer = false;
    },

    showHistory(vehicle, day = null, ride = null, refreshRide = false) {
      this.$store.dispatch("online/mapMode", "history");
      if (this.map !== null)
        this.map.closePopup();

      const dayValue = (day === null) ? DateTime.now().startOf("day") : day;

      this.$store.dispatch("history/fetch", {
        vehicleId: vehicle.vehicleId,
        vehicle: null,
        periodFrom: DateTime.fromISO(dayValue).toISO(),
        periodTo: DateTime.fromISO(dayValue).plus({ seconds: 86399 }).toISO(),
        rideFrom: ride,
        last: true
      }).then(() => {
        if (refreshRide) {
          const tid = setInterval(function() {
            this.refreshHistoryRide();
            clearTimeout(tid);
          }.bind(this), 5);
        }
      });
    },

    showLogbook(vehicle, month = null, ride = null) {
      this.$store.dispatch("online/mapMode", "logbook");
      if (this.map !== null)
        this.map.closePopup();

      const m = (month) ? DateTime.fromFormat(month, "yyyy-M") : DateTime.now();
      this.$store.dispatch("logbook/fetch", {
        vehicle: vehicle,
        periodFrom: m.startOf("month").toISO(),
        periodTo: m.endOf("month").toISO(),
        rideFrom: ride,
        last: true
      });
    },

    showRefueling(vehicle, month = null, refueling = null) {
      this.$store.dispatch("online/mapMode", "refueling");
      if (this.map !== null)
        this.map.closePopup();

      const m = (month) ? DateTime.fromFormat(month, "yyyy-M") : DateTime.now();
      this.$store.dispatch("refueling/fetch", {
        vehicle: vehicle,
        periodFrom: m.startOf("month").toISO(),
        periodTo: m.endOf("month").toISO(),
        timestamp: refueling,
        last: true
      });
    },

    showEvents(vehicle, month = null, event = null) {
      this.$store.dispatch("online/mapMode", "events");
      if (this.map !== null)
        this.map.closePopup();

      const m = (month) ? DateTime.fromFormat(month, "yyyy-M") : DateTime.now();
      const p = (event !== null) ? event.split("@") : [null, null];

      this.$store.dispatch("events/fetch", {
        vehicle: vehicle,
        periodFrom: m.startOf("month").toISO(),
        periodTo: m.endOf("month").toISO(),
        timestamp: p[0],
        parameterId: p[1],
        last: true
      });
    },

    showContracts(vehicle, month = null, contract = null) {
      this.$store.dispatch("online/mapMode", "contracts");
      if (this.map !== null)
        this.map.closePopup();

      const m = (month) ? DateTime.fromFormat(month, "yyyy-M") : DateTime.now();

      this.$store.dispatch("contracts/fetch", {
        vehicle: vehicle,
        periodFrom: m.startOf("month").toISO(),
        periodTo: m.endOf("month").toISO(),
        contractId: utils.toNumber(contract),
        last: true
      });
    },

    showService(vehicle, plan = null) {
      this.$store.dispatch("online/mapMode", "service");
      if (this.map !== null)
        this.map.closePopup();

      this.$store.dispatch("service/fetch", {
        vehicle: vehicle,
        planId: utils.toNumber(plan),
        last: true
      });
    },

    /**
     * Aktualizuje online vozidla na mapě
     */
    refreshMapVehicles() {
      let layer = new L.LayerGroup();
      let vehicleLayer = null;
      var popupFeature = null;

      this.$store.state.online.visibleVehicles.forEach(vehicle => {
        if (vehicle.location !== null && vehicle.location !== undefined) {
          var options = maputils.trackSymbolVehicleOptions(vehicle);

          options.data = vehicle;

          let trackSymbol = maputils.trackSymbol(
            [vehicle.location.latitude, vehicle.location.longitude],
            options);

          var tooltip = vehicle.numericPlate;
          let diff = DateTime.fromISO(vehicle.location.timestamp).diff(DateTime.now());

          if (Math.abs(diff.as("minutes")) >= 8)
            tooltip += "<br/><span class=\"smaller cred\">"
              + DateTime.fromISO(vehicle.location.timestamp).toRelative(DateTime.now()) + "</span>";

          trackSymbol.bindTooltip(tooltip, {
            permanent: true,
            interactive: true,
            direction: "right",
            offset: [5, 0],
            className: "tooltip-map-vehicle"
          });
          trackSymbol.on("click", this.vehiclePopupClick);
          trackSymbol.addTo(layer);

          if (this.vehiclePopup.popup !== null && vehicle.vehicleId === this.vehiclePopup.vehicle.vehicleId)
            popupFeature = trackSymbol;
        }
      });

      let selectedVehicle = null;
      if (this.vehicle !== null) {
        const vehicle = this.$store.state.online.vehicles.find(x => this.vehicle.vehicleId === x.vehicleId);

        if (vehicle !== null) {
          const options = {};

          if (vehicle.ride !== null && vehicle.ride.rideState === "unfinished") {
            if (vehicle.location.speed >= 5) {
              options.defaultSymbol = maputils.SYMBOL_ARROW;
              options.heading = vehicle.location.direction * (Math.PI / 180.0);
            } else {
              options.defaultSymbol = maputils.SYMBOL_CIRCLE;
              options.heading = 0;
            }
          } else {
            options.defaultSymbol = maputils.SYMBOL_SQUERE;
            options.heading = 0;
          }

          switch (utils.vehicleState(vehicle)) {
            case "FAIL":
              options.color = maputils.COLOR_FAIL;
              options.fillColor = maputils.COLOR_FAIL_FILL;
              break;
            default:
              options.color = maputils.COLOR_ACTIVE;
              options.fillColor = maputils.COLOR_ACTIVE_FILL;
              break;
          }

          options.data = vehicle;

          let vehicleSymbol = maputils.trackSymbol(
            [vehicle.location.latitude, vehicle.location.longitude],
            options);

          var vehicleTooltip = vehicle.numericPlate;
          let diff = DateTime.fromISO(vehicle.location.timestamp).diff(DateTime.now());

          if (Math.abs(diff.as("minutes")) >= 8)
            vehicleTooltip += "<br/><span class=\"smaller cred\">"
              + DateTime.fromISO(vehicle.location.timestamp).toRelative() + "</span>";

          vehicleSymbol.bindTooltip(vehicleTooltip, {
            permanent: true,
            interactive: true,
            direction: "right",
            offset: [5, 0],
            className: "tooltip-map-vehicle"
          });

          vehicleLayer = new L.LayerGroup();
          vehicleSymbol.addTo(vehicleLayer);

          selectedVehicle = vehicle;

          popupFeature = null;
        }
      }

      if (this.onlineLayer != null) {
        this.onlineLayer.removeFrom(this.map);
        this.onlineLayer.clearLayers();
      }

      if (this.vehicleLayer != null) {
        this.vehicleLayer.removeFrom(this.map);
        this.vehicleLayer.clearLayers();
      }

      this.onlineLayer = layer;
      this.vehicleLayer = vehicleLayer;

      // vrstvu pridej pouze pokud neni zapla historie
      if (this.history === null && this.logbook === null && this.refueling === null && this.events === null && this.contracts === null) {
        if (this.vehicle !== null) {
          this.map.closePopup();
          this.vehicleLayer.addTo(this.map);
          this.centerVehicle(selectedVehicle);
        } else {
          this.onlineLayer.addTo(this.map);

          if (this.onlineZoom) {
            this.onlineZoom = false;
            this.zoomToFeatures();
          }
        }

        if (popupFeature !== null)
          this.vehiclePopupShow(popupFeature,
            [popupFeature.options.data.location.latitude, popupFeature.options.data.location.longitude]);
      }
    },

    route(to) {
      if (to.name === "map") {
        this.showOnline();
        this.onlineZoom = true;
        this.refreshMapVehicles();
        return;
      }

      const t = this;

      utils.wait(() => {
        if (t.$store.state.auth.company !== null && t.$store.state.auth.company.code === to.params.ccode &&
          t.$store.state.online.fetched) {
          const vehicle = t.$store.state.online.vehicles.find(x => x.vehicleId === utils.toNumber(to.params.id));

          switch (to.name) {
            case "map/vehicle":
              if (vehicle !== undefined)
                t.showVehicle(vehicle);
              break;

            case "map/logbook":
              if (vehicle !== undefined)
                t.showLogbook(vehicle, this.$route.query["month"], this.$route.query["ride"]);
              break;

            case "map/refueling":
              if (vehicle !== undefined)
                t.showRefueling(vehicle, this.$route.query["month"], this.$route.query["refueling"]);
              break;

            case "map/events":
              if (vehicle !== undefined)
                t.showEvents(vehicle, this.$route.query["month"], this.$route.query["event"]);
              break;

            case "map/contracts":
              if (vehicle !== undefined)
                t.showContracts(vehicle, this.$route.query["month"], this.$route.query["contract"]);
              break;

            case "map/service":
              if (vehicle !== undefined)
                t.showService(vehicle, this.$route.query["plan"]);
              break;

            case "map/history":
              if (vehicle !== undefined)
                t.showHistory(vehicle, this.$route.query["day"], this.$route.query["ride"], true);
              break;
          }

          return true;
        } else
          return false;
      }, [50, 50, 100, 100, 300, 500, 500, 1000, 2000, 3000]);
    },

    refreshHistoryRide() {
      if (this.historyLayer !== null) {
        var group = new L.featureGroup();

        var next_inactive = true;

        this.historyLayer.getLayers().forEach(layer => {
          if (this.$store.state.history.ride === null || layer.properties.id === this.$store.state.history.ride.fromTimestamp) {
            group.addLayer(layer);
            layer.setStyle(this.historySelectedStyle);
            layer.eachLayer(x => {
              if (x.feature.marker !== undefined) {
                x.feature.marker.setIcon(this.featureIcon(x.feature, false));
                x.feature.marker.setZIndexOffset(1000);
                next_inactive = false;
              }
            });

            if (layer.properties.ride !== null && layer.properties.ride.distance < 50)
              next_inactive = true;

            layer.bringToFront();
          } else {
            layer.eachLayer(x => {
              if (x.feature.marker !== undefined) {
                x.feature.marker.setIcon(this.featureIcon(x.feature, next_inactive));
                x.feature.marker.setZIndexOffset((next_inactive) ? -1000 : 1000);
                next_inactive = true;
              }
            });
            layer.setStyle(this.historyStyle);
          }
        });

        if (group.getLayers().length > 0) {
          this.map.fitBounds(group.getBounds(), { padding: [40, 40] });

          if (this.zoomToFeaturesTimer !== null) {
            clearInterval(this.zoomToFeaturesTimer);
            this.zoomToFeaturesTimer = null;
          }
        }

      }
    },

    showHistoryLocationPopup(ts) {
      if (this.$store.state.history.locations === null || ts === null) {
        this.map.closePopup();
        return;
      }

      const location = this.$store.state.history.locations.find(l => DateTime.fromISO(l.timestamp).equals(ts));

      if (location === null) {
        this.map.closePopup();
        return;
      }

      let dynamicValues = "";
      let altitudeStyle = "";
      let speedStyle = "";
      const defs = this.$store.state.history.defs;

      this.$store.state.history.selected.forEach(x => {
        const def = defs[x];
        if (def.measure && location.measure !== null && x in location.measure) {
          dynamicValues += `
<tr>
  <td><span style="border-left: 5px solid ${def.color}; padding-left: 5px">
    ${def.format(def.getter(location)) + " " + this.$t("map.panel.history.graph." + def.name + ".unit")}
  </span></td>
</tr>`;
        } else if (x === "altitude")
          altitudeStyle = "border-left: 5px solid " + def.color + "; padding-left: 5px";
        else if (x === "speed")
          speedStyle = "border-left: 5px solid " + def.color + "; padding-left: 5px";
      });

      const popup = L.popup({ closeButton: false, className: "location-popup" });
      popup
        .setLatLng([location.latitude, location.longitude])
        .setContent(`
<table>
  <tr>
    <td colspan="2">
      ${DateTime.fromISO(location.timestamp).toLocaleString(DateTime.DATE_SHORT)} <b>${DateTime.fromISO(location.timestamp).toLocaleString(DateTime.TIME_24_SIMPLE)}</b>
    </td>
  </tr>
  <tr>
    <td><span style="${speedStyle}">${location.speed + " km/h"}</span></td>
    <td rowspan="2">
      <span class="material-icons" style="padding: 3px; font-size: 30px; transform: rotate(${location.direction}deg)">navigation</span>
    </td>
  </tr>
  <tr>
    <td><span style="${altitudeStyle}">${location.altitude + " m n.m"}</span></td>
  </tr>
  ${dynamicValues}
</table>`).openOn(this.map);
    }
  },

  watch: {
    $route(to) {
      this.route(to);
    },

    "$store.state.auth.company": function() {
      this.onlineZoom = true;
    },

    "$store.state.online.visibleVehicles": function() {
      this.refreshMapVehicles();
    },

    vehicle: function() {
      this.refreshMapVehicles();
    },

    "$store.state.online.mapMode": function() {
      const mode = this.$store.state.online.mapMode;

      if (this.onlineLayer !== null && mode !== "online")
        this.onlineLayer.removeFrom(this.map);
      if (this.vehicleLayer !== null && mode !== "vehicle" && mode === "service")
        this.vehicleLayer.removeFrom(this.map);
      if (this.historyLayer !== null && mode !== "history")
        this.historyLayer.removeFrom(this.map);
      if (this.logbookLayer !== null && mode !== "logbook")
        this.logbookLayer.removeFrom(this.map);
      if (this.refuelingLayer !== null && mode !== "refueling")
        this.refuelingLayer.removeFrom(this.map);
      if (this.eventsLayer !== null && mode !== "events")
        this.eventsLayer.removeFrom(this.map);

      if (this.onlineLayer !== null && (mode === "vehicle" || mode === "service"))
        this.refreshMapVehicles();
    },

    "$store.state.history.ride": function() {
      this.refreshHistoryRide();
    },

    "$store.state.history.locations": function() {
      // vymaz aktualni vrstvy
      if (this.historyLayer !== null) {
        this.map.removeLayer(this.historyLayer);
        this.historyLayer = null;
      }

      if (this.$store.state.history.vehicle != null && this.$store.state.history.locations != null
        && this.$store.state.history.locations.length > 0) {
        var rides = [];
        var ridesMap = new Map();
        var order = 1;

        this.$store.state.history.rides.forEach(
          x => {
            let ride = {
              name: "Ride",
              type: "FeatureCollection",
              properties: {
                id: x.fromTimestamp,
                ride: x
              },
              features: [
                {
                  type: "Feature",
                  geometry: {
                    type: "Point",
                    coordinates: []
                  },
                  properties: {
                    rideType: x.rideType,
                    splitBy: x.splitBy,
                    rideState: x.rideState,
                    distance: x.distance,
                    tankDiff: x.tankDiff,
                    timestamp: x.fromTimestamp,
                    order: order++
                  }
                }
              ]
            };

            // zjisti zda jde o parkovaní nebo zastávku
            if (rides.length > 0) {
              if (x.rideType === "bussines" || x.rideType === "private") {
                const duration = DateTime.fromISO(x.fromTimestamp).diff(DateTime.fromISO(rides[rides.length - 1].toTimestamp));
                if (duration.as("minutes") > 45)
                  ride.features[0].properties.rideType = "parking";
                else
                  ride.features[0].properties.rideType = "pin";
              }
            }

            ridesMap[x.fromTimestamp] = ride;
            rides.push(ride);
          }
        );

        if (rides.length > 0) {
          let last_lat = null;
          let last_lon = null;
          let last_ride = null;

          this.$store.state.history.locations.forEach(
            x => {
              if (x.rideTs !== null) {
                const ride = ridesMap[x.rideTs];

                if (ride !== null && ride !== undefined) {
                  if (last_lat === null || ride.features[0].geometry.coordinates.length === 0) {
                    ride.features[0].geometry.coordinates = [x.longitude, x.latitude];

                    if (last_ride !== null) {
                      const feature = {
                        type: "Feature",
                        geometry: {
                          type: "LineString",
                          coordinates: [[last_lon, last_lat], [x.longitude, x.latitude]]
                        },
                        properties: {
                          type: "L",
                          timestamp: x.timestamp,
                          speed: x.speed,
                          altitude: x.altitude,
                          acceleration: x.acceleration,
                          deceleration: x.deceleration,
                          cornering: x.cornering
                        }
                      };

                      last_ride.features.push(feature);
                    }
                  } else {
                    const feature = {
                      type: "Feature",
                      geometry: {
                        type: "LineString",
                        coordinates: [[last_lon, last_lat], [x.longitude, x.latitude]]
                      },
                      properties: {
                        type: "L",
                        timestamp: x.timestamp,
                        speed: x.speed,
                        altitude: x.altitude,
                        direction: x.direction,
                        acceleration: x.acceleration,
                        deceleration: x.deceleration,
                        cornering: x.cornering,
                        measure: x.measure
                      }
                    };

                    ride.features.push(feature);
                  }

                  last_lat = x.latitude;
                  last_lon = x.longitude;
                  last_ride = ride;
                }
              }
            });

          // umístí stop
          let lastRide = rides[rides.length - 1];

          lastRide.features.push(
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: (lastRide.features.length === 1)
                  ? lastRide.features[lastRide.features.length - 1].geometry.coordinates
                  : lastRide.features[lastRide.features.length - 1]
                    .geometry.coordinates[lastRide.features[lastRide.features.length - 1].geometry.coordinates.length - 1]
              },
              properties: {
                rideType: (lastRide.features[0].properties.rideState === "unfinished") ? "actual" : "stop",
                distance: 0,
                timestamp: lastRide.properties.ride.toTimestamp
              }
            }
          );
        } else {
          // žádná jízda během dne, zobraz alespoň boc pokud je
          if (this.$store.state.history.locations.length > 0) {
            let location = this.$store.state.history.locations[0];

            let ride = {
              name: "Ride",
              type: "FeatureCollection",
              properties: {
                id: location.timestamp,
                ride: null
              },
              features: [
                {
                  type: "Feature",
                  geometry: {
                    type: "Point",
                    coordinates: [location.longitude, location.latitude]
                  },
                  properties: {
                    rideType: "parking"
                  }
                }
              ]
            };

            rides.push(ride);
          }
        }

        this.historyLayer = new L.LayerGroup();

        // vymaz všechny jízdy bez pozic
        rides = rides.filter(x => x.features[0].geometry.coordinates.length > 0);
        const map = this.map;
        const popup = L.popup({ closeButton: false, className: "location-popup" });
        let history_ride = this.$store.state.history;

        rides.forEach(x => {
          let layer = new L.geoJSON(x, this.historyOptions);
          layer.properties = x.properties;
          const thisCall = this;
          const defs = this.$store.state.history.defs;

          layer.on("mouseover", function(e) {
            if ((history_ride.ride === null || history_ride.ride.fromTimestamp === e.target.properties.id)
              && e.propagatedFrom !== null && e.propagatedFrom.feature !== null) {
              if (e.propagatedFrom.feature.properties.type === "L") {
                let dynamicValues = "";
                let altitudeStyle = "";
                let speedStyle = "";

                thisCall.$store.state.history.selected.forEach(x => {
                  const def = defs[x];
                  if (def.measure && e.propagatedFrom.feature.properties.measure !== null && x in e.propagatedFrom.feature.properties.measure) {
                    dynamicValues += `
<tr>
  <td><span style="border-left: 5px solid ${def.color}; padding-left: 5px">
    ${def.format(def.getter(e.propagatedFrom.feature.properties)) + " " + thisCall.$t("map.panel.history.graph." + def.name + ".unit")}
  </span></td>
</tr>`;
                  } else if (x === "altitude")
                    altitudeStyle = "border-left: 5px solid " + def.color + "; padding-left: 5px";
                  else if (x === "speed")
                    speedStyle = "border-left: 5px solid " + def.color + "; padding-left: 5px";
                });

                popup
                  .setLatLng(e.latlng)
                  .setContent(`
<table>
  <tr>
    <td colspan="2">
        ${DateTime.fromISO(e.propagatedFrom.feature.properties.timestamp).toLocaleString(DateTime.DATE_SHORT)} <b>${DateTime.fromISO(e.propagatedFrom.feature.properties.timestamp).toLocaleString(DateTime.TIME_24_SIMPLE)}</b>
    </td>
  </tr>
  <tr>
    <td><span style="${speedStyle}">${e.propagatedFrom.feature.properties.speed + " km/h"}</span></td>
    <td rowspan="2">
      <span class="material-icons" style="padding: 3px; font-size: 30px; transform: rotate(${e.propagatedFrom.feature.properties.direction}deg)">navigation</span>
    </td>
  </tr>
  <tr>
    <td><span style="${altitudeStyle}">${e.propagatedFrom.feature.properties.altitude + " m n.m"}</span></td>
  </tr>
  ${dynamicValues}
</table>`).openOn(map);
              }
            }
          });

          const store = this.$store;

          layer.on("mouseout", function() {
            map.closePopup();
          });

          layer.on("click", function() {
            store.dispatch("history/fetch", {
              periodFrom: store.state.history.periodFrom,
              periodTo: store.state.history.periodTo,
              rideFrom: (store.state.history.ride === null || this.properties.id !== store.state.history.ride.fromTimestamp) ? this.properties.id : null
            });
          });

          this.historyLayer.addLayer(layer);
        });

        this.historyLayer.addTo(this.map);

        /*let group = new L.featureGroup();
        group.addLayer(this.vehicleHistoryLayer);

        this.map.fitBounds(group.getBounds(), {padding: [25, 25]});*/

        this.zoomToFeatures();
      }
    },

    "$store.state.logbook.locations": function() {
      // vymaz aktualni vrstvy
      if (this.logbookLayer !== null) {
        this.map.removeLayer(this.logbookLayer);
        this.logbookLayer = null;
      }

      if (this.$store.state.logbook.vehicle != null && this.$store.state.logbook.locations != null
        && this.$store.state.logbook.locations.length > 0) {
        var ride = {
          name: "Ride",
          type: "FeatureCollection",
          properties: {
            id: this.$store.state.logbook.ride.fromTimestamp,
            ride: this.$store.state.logbook.ride
          },
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [this.$store.state.logbook.locations[0].longitude,
                  this.$store.state.logbook.locations[0].latitude]
              },
              properties: {
                rideType: this.$store.state.logbook.ride.rideType,
                splitBy: this.$store.state.logbook.ride.splitBy,
                rideState: this.$store.state.logbook.ride.rideState,
                distance: this.$store.state.logbook.ride.distance,
                tankDiff: this.$store.state.logbook.ride.tankDiff,
                timestamp: this.$store.state.logbook.ride.fromTimestamp
              }
            },
            {
              type: "Feature",
              geometry: {
                type: "LineString",
                coordinates: []
              },
              properties: {}
            }
          ]
        };

        if (this.$store.state.logbook.ride.rideType === "bussines" || this.$store.state.logbook.ride.rideType === "private") {
          let location = this.$store.state.logbook.locations[this.$store.state.logbook.locations.length - 1];

          let feature = {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [location.longitude, location.latitude]
            },
            properties: {
              rideType: "stop",
              timestamp: this.$store.state.logbook.ride.toTimestamp
            }
          };

          ride.features.push(feature);
        }

        let last_lat = null;
        let last_lon = null;

        this.$store.state.logbook.locations.forEach(
          x => {
            if (last_lat !== null) {
              const feature = {
                type: "Feature",
                geometry: {
                  type: "LineString",
                  coordinates: [[last_lon, last_lat], [x.longitude, x.latitude]]
                },
                properties: {
                  type: "L",
                  timestamp: x.timestamp,
                  speed: x.speed,
                  altitude: x.altitude,
                  direction: x.direction
                }
              };

              ride.features.push(feature);
            }

            last_lat = x.latitude;
            last_lon = x.longitude;
          });

        const map = this.map;
        const popup = L.popup({ closeButton: false, className: "location-popup" });

        this.logbookLayer = new L.LayerGroup();
        let layer = new L.geoJSON(ride, this.logbookOptions);

        layer.on("mouseover", function(e) {
          if (e.propagatedFrom !== null && e.propagatedFrom.feature !== null) {
            if (e.propagatedFrom.feature.properties.type === "L") {
              popup
                .setLatLng(e.latlng)
                .setContent(`
<table>
  <tr>
    <td colspan="2">
      ${DateTime.fromISO(e.propagatedFrom.feature.properties.timestamp).toLocaleString(DateTime.DATE_SHORT)} <b>${DateTime.fromISO(e.propagatedFrom.feature.properties.timestamp).toFormat("HH:mm")}</b>
    </td>
  </tr>
  <tr>
    <td>${e.propagatedFrom.feature.properties.speed + " km/h"}</td>
    <td rowspan="2">
      <span class="material-icons" style="padding: 3px; font-size: 30px; transform: rotate(${e.propagatedFrom.feature.properties.direction}deg)">navigation</span>
    </td>
  </tr>
  <tr>
    <td>${e.propagatedFrom.feature.properties.altitude + " m n.m"}</td>
  </tr>
</table>`).openOn(map);
            }

          }
        });

        layer.on("mouseout", function() {
          map.closePopup();
        });

        this.logbookLayer.addLayer(layer);

        this.logbookLayer.addTo(this.map);

        this.zoomToFeatures();
      }
    },

    "$store.state.refueling.refueling": function() {
      // vymaz aktualni vrstvy
      if (this.refuelingLayer !== null) {
        this.map.removeLayer(this.refuelingLayer);
        this.refuelingLayer = null;
      }

      if (this.$store.state.refueling.vehicle != null && this.$store.state.refueling.refueling != null
        && this.$store.state.refueling.refueling.measure) {
        const measure = this.$store.state.refueling.refueling.measure[0];
        var ride = {
          name: "Ride",
          type: "FeatureCollection",
          properties: {
            id: measure.fromTimestamp,
            ride: measure
          },
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [measure.locationFrom.longitude, measure.locationFrom.latitude]
              },
              properties: {
                rideType: measure.rideType,
                splitBy: measure.splitBy,
                rideState: measure.rideState,
                distance: measure.distance,
                tankDiff: measure.tankDiff,
                timestamp: measure.fromTimestamp
              }
            }
          ]
        };


        this.refuelingLayer = new L.LayerGroup();
        let layer = new L.geoJSON(ride, this.refuelingOptions);

        this.refuelingLayer.addLayer(layer);
        this.refuelingLayer.addTo(this.map);

        this.zoomToFeatures();
      }
    },

    "$store.state.events.event": function() {
      // vymaz aktualni vrstvy
      if (this.eventsLayer !== null) {
        this.map.removeLayer(this.eventsLayer);
        this.eventsLayer = null;
      }

      if (this.$store.state.events.vehicle != null && this.$store.state.events.event != null
        && this.$store.state.events.event.location != null) {
        const measure = this.$store.state.events.event;
        const location = {
          name: "Ride",
          type: "FeatureCollection",
          properties: {
            id: measure.timestamp,
            ride: measure
          },
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [measure.location.longitude, measure.location.latitude]
              },
              properties: {
                timestamp: measure.timestamp
              }
            }
          ]
        };

        this.eventsLayer = new L.LayerGroup();
        let layer = new L.geoJSON(location, this.eventsOptions);
        this.eventsLayer.addLayer(layer);
        this.eventsLayer.addTo(this.map);

        this.zoomToFeatures();
      }
    },

    "$store.state.contracts.contract": function() {
      // vymaz aktualni vrstvy
      if (this.contractLayer !== null) {
        this.map.removeLayer(this.contractLayer);
        this.contractLayer = null;
      }

      if (this.$store.state.contracts.contract != null) {
        this.contractLayer = new L.LayerGroup();

        // zobraz plan
        if (this.$store.state.contracts.contract.plan != null) {
          var planRides = [];
          const plan = this.$store.state.contracts.contract.plan;

          let last_pos = null;

          plan.parts.forEach(
            x => {
              let ride = {
                name: "Ride",
                type: "FeatureCollection",
                properties: {
                  id: x.fromIndex,
                  part: x
                },
                features: [
                  {
                    type: "Feature",
                    geometry: {
                      type: "Point",
                      coordinates: plan.path[x.fromIndex]
                    },
                    properties: {
                      text: plan.waypoints[x.pointFromIndex].name,
                      distance: x.distance,
                      duration: x.duration
                    }
                  }
                ]
              };

              plan.path.slice(x.fromIndex, x.toIndex).forEach(
                x => {
                  if (last_pos !== null) {
                    const feature = {
                      type: "Feature",
                      geometry: {
                        type: "LineString",
                        coordinates: [last_pos, x]
                      },
                      properties: {
                        type: "P"
                      }
                    };

                    ride.features.push(feature);
                  }

                  last_pos = x;
                });

              planRides.push(ride);
            }
          );

          const last_ride = plan.parts[plan.parts.length - 1];
          planRides.push({
            name: "Ride",
            type: "FeatureCollection",
            properties: {
              id: last_ride.toIndex,
              part: last_ride
            },
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: plan.path[last_ride.toIndex]
                },
                properties: {
                  text: plan.waypoints[last_ride.pointToIndex].name,
                  distance: 0,
                  duration: 0
                }
              }
            ]
          });

          planRides.forEach(x => {
            let layer = new L.geoJSON(x, this.contractOptions);
            layer.properties = x.properties;
            this.contractLayer.addLayer(layer);
          });
        }

        // zobraz skutecnou jizdu
        if (this.$store.state.contracts.contract.rides != null && this.$store.state.contracts.contract.rides.length > 1) {
          var rides = [];
          var ridesMap = new Map();
          var order = 1;

          this.$store.state.contracts.contract.rides.forEach(
            x => {
              let ride = {
                name: "Ride",
                type: "FeatureCollection",
                properties: {
                  id: x.fromTimestamp,
                  ride: x
                },
                features: [
                  {
                    type: "Feature",
                    geometry: {
                      type: "Point",
                      coordinates: []
                    },
                    properties: {
                      rideType: x.rideType,
                      splitBy: x.splitBy,
                      rideState: x.rideState,
                      distance: x.distance,
                      tankDiff: x.tankDiff,
                      timestamp: x.fromTimestamp,
                      order: order++
                    }
                  }
                ]
              };

              // zjisti zda jde o parkovaní nebo zastávku
              if (rides.length > 0) {
                if (x.rideType === "bussines" || x.rideType === "private") {
                  const duration = DateTime.fromISO(x.fromTimestamp).diff(DateTime.fromISO(rides[rides.length - 1].toTimestamp));
                  if (duration.as("minutes") > 45)
                    ride.features[0].properties.rideType = "parking";
                  else
                    ride.features[0].properties.rideType = "pin";
                }
              }

              ridesMap[x.fromTimestamp] = ride;
              rides.push(ride);
            }
          );

          let last_lat = null;
          let last_lon = null;
          let last_ride = null;

          this.$store.state.contracts.locations.forEach(
            x => {
              if (x.rideTs !== null) {
                const ride = ridesMap[x.rideTs];

                if (ride !== null && ride !== undefined) {
                  if (last_lat === null || ride.features[0].geometry.coordinates.length === 0) {
                    ride.features[0].geometry.coordinates = [x.longitude, x.latitude];

                    if (last_ride !== null) {
                      const feature = {
                        type: "Feature",
                        geometry: {
                          type: "LineString",
                          coordinates: [[last_lon, last_lat], [x.longitude, x.latitude]]
                        },
                        properties: {
                          type: "L",
                          timestamp: x.timestamp,
                          speed: x.speed,
                          altitude: x.altitude,
                          acceleration: x.acceleration,
                          deceleration: x.deceleration,
                          cornering: x.cornering
                        }
                      };

                      last_ride.features.push(feature);
                    }
                  } else {
                    const feature = {
                      type: "Feature",
                      geometry: {
                        type: "LineString",
                        coordinates: [[last_lon, last_lat], [x.longitude, x.latitude]]
                      },
                      properties: {
                        type: "L",
                        timestamp: x.timestamp,
                        speed: x.speed,
                        altitude: x.altitude,
                        direction: x.direction,
                        acceleration: x.acceleration,
                        deceleration: x.deceleration,
                        cornering: x.cornering,
                        measure: x.measure
                      }
                    };

                    ride.features.push(feature);
                  }

                  last_lat = x.latitude;
                  last_lon = x.longitude;
                  last_ride = ride;
                }
              }
            });

          // umístí stop
          let lastRide = rides[rides.length - 1];

          lastRide.features.push(
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: (lastRide.features.length === 1)
                  ? lastRide.features[lastRide.features.length - 1].geometry.coordinates
                  : lastRide.features[lastRide.features.length - 1]
                    .geometry.coordinates[lastRide.features[lastRide.features.length - 1].geometry.coordinates.length - 1]
              },
              properties: {
                rideType: (lastRide.features[0].properties.rideState === "unfinished") ? "actual" : "stop",
                distance: 0,
                timestamp: lastRide.properties.ride.toTimestamp
              }
            }
          );

          // vymaz všechny jízdy bez pozic
          rides = rides.filter(x => x.features[0].geometry.coordinates.length > 0);
          const map = this.map;
          const popup = L.popup({ closeButton: false, className: "location-popup" });

          rides.forEach(x => {
            let layer = new L.geoJSON(x, this.historyOptions);
            layer.properties = x.properties;

            layer.on("mouseover", function(e) {
              if (e.propagatedFrom !== null && e.propagatedFrom.feature !== null) {
                if (e.propagatedFrom.feature.properties.type === "L") {
                  popup
                    .setLatLng(e.latlng)
                    .setContent(`
<table>
  <tr>
    <td colspan="2">
        ${DateTime.fromISO(e.propagatedFrom.feature.properties.timestamp).toLocaleString(DateTime.DATE_SHORT)} <b>${DateTime.fromISO(e.propagatedFrom.feature.properties.timestamp).toLocaleString(DateTime.TIME_24_SIMPLE)}</b>
    </td>
  </tr>
  <tr>
    <td><span>${e.propagatedFrom.feature.properties.speed + " km/h"}</span></td>
    <td rowspan="2">
      <span class="material-icons" style="padding: 3px; font-size: 30px; transform: rotate(${e.propagatedFrom.feature.properties.direction}deg)">navigation</span>
    </td>
  </tr>
  <tr>
    <td><span>${e.propagatedFrom.feature.properties.altitude + " m n.m"}</span></td>
  </tr>
</table>`).openOn(map);
                }
              }
            });

            layer.on("mouseout", function() {
              map.closePopup();
            });

            this.contractLayer.addLayer(layer);
          });
        }

        // varstva
        this.contractLayer.addTo(this.map);

        this.zoomToFeatures();
      }
    }
  },

  computed: {
    vehicle() {
      return this.$store.state.online.vehicle || this.$store.state.service.vehicle;
    },

    history() {
      return this.$store.state.history.vehicle;
    },

    logbook() {
      return this.$store.state.logbook.vehicle;
    },

    refueling() {
      return this.$store.state.refueling.vehicle;
    },

    events() {
      return this.$store.state.events.vehicle;
    },

    contracts() {
      return this.$store.state.contracts.vehicle;
    },

    plans() {
      return this.$store.state.service.vehicle;
    },

    vehicles() {
      return this.$store.state.online.vehicles;
    },

    refreshVisible() {
      return this.$store.state.online.mapMode === "online"
        || this.$store.state.online.mapMode === "vehicle";
    },

    refreshEnabled() {
      return this.$store.state.online.refreshTimeout === null;
    },

    filteredVehicles() {
      return this.$store.state.online.filteredVehicles;
    }
  },

  mounted() {
    this.$nextTick().then(() => {
      this.route(this.$route);
    });
  }
};
</script>

<style lang="sass">
.tooltip-map-vehicle
  border: none !important
  box-shadow: none !important
  font-weight: bold
  font-size: 13px
  text-shadow: -2px -2px 1px white, 2px -2px 1px white, -2px 2px 1px white, 2px 2px 1px white
  line-height: 100%
  background: transparent !important
  margin-left: 10px

.tooltip-map-vehicle .smaller
  font-size: 12px

.tooltip-map-vehicle .cred
  color: red

.tooltip-map-vehicle:before
  border: none !important

.map
  height: 100%
  width: 100%

.v-btn
  min-width: 0

.v-btn-group-vertical
  border-radius: 4px
  display: inline-flex
  flex-direction: column

  .theme--dark &
    background: #424242

  .theme--light &
    background: #fff

  .v-btn
    border-radius: 0
    justify-content: center
    margin: 0
    min-width: 32px !important
    min-height: 32px !important
    padding: 0 8px

    &:not(:last-child)
      border-bottom: 1px solid transparent !important

    &:first-child
      border-radius: 4px 4px 0 0

    &:last-child
      border-radius: 0 0 4px 4px

.leaflet-hcenter
  left: 50%
  transform: translate(-50%, 0%)

.leaflet-vcenter
  position: absolute
  z-index: 1000
  pointer-events: none
  top: 50%
  transform: translateY(-50%)
  padding-top: 10px

.leaflet-vcenter .leaflet-control
  margin-bottom: 10px

.leaflet-popup-content-wrapper
  border-radius: 5px !important

.leaflet-popup-content
  margin: 0 !important

.location-popup .leaflet-popup-content
  padding: 5px

.leaflet-fade-anim .leaflet-popup
  transition: none

.location-marker
  position: absolute
  white-space: nowrap
  -webkit-user-select: none
  -moz-user-select: none
  -ms-user-select: none
  user-select: none
  pointer-events: none
  width: 0
  height: 0
  border: 0
  padding: 0

.location-marker-wrapper
  display: inline-block
  border: 0 solid #000
  transform: translate(-50%, -100%) translate(0, -9px)

.location-marker-content
  border-radius: 4px
  border: 0 solid #000
  padding: 4px
  color: #111
  background-color: rgba(203, 217, 255, 1.0)
  box-shadow: 0 1px 3px rgba(25, 25, 25, 1.0)

.location-marker-content .location-marker-order
  background-color: rgba(60, 60, 60, 1.0)
  color: rgba(240, 240, 240, 1.0)
  border-radius: 5px
  padding: 0 3px
  margin-left: 4px
  font-weight: bold

.location-deselected .location-marker-content
  background-color: rgba(220, 220, 220, 1.0) !important

.location-marker-content table td
  line-height: 0.9

.location-marker-tip-container
  width: 24px
  height: 12px
  position: absolute
  left: 50%
  margin-top: 0px
  margin-left: -12px
  overflow: hidden
  pointer-events: none

.location-marker-tip
  border: 0px solid #000
  background-color: rgba(203, 217, 255, 1.0)
  box-shadow: 0 1px 3px rgba(25, 25, 25, 1.0)
  width: 12px
  height: 12px
  padding: 1px
  margin: -8px auto 0
  pointer-events: auto
  transform: rotate(45deg)

.location-deselected .location-marker-tip
  background-color: rgba(220, 220, 220, 1.0) !important

.plan-marker
  position: absolute
  white-space: nowrap
  -webkit-user-select: none
  -moz-user-select: none
  -ms-user-select: none
  user-select: none
  pointer-events: none
  width: 0
  height: 0
  border: 0
  padding: 0

.plan-marker-wrapper
  display: inline-block
  border: 0 solid #000
  transform: translate(-50%, 50%) translate(0, -1px)

.plan-marker-content
  border-radius: 4px
  border: 0 solid #000
  padding: 4px
  color: #111
  background-color: rgb(255, 119, 243)
  box-shadow: 0 1px 3px rgba(25, 25, 25, 1.0)

.plan-marker-tip-container
  width: 24px
  height: -12px
  position: absolute
  left: 50%
  top: -18px
  margin-left: -12px
  overflow: hidden
  pointer-events: none

.plan-marker-tip
  border: 0px solid #000
  background-color: rgb(255, 119, 243)
  width: 12px
  height: 12px
  padding: 1px
  margin: 12px auto 0
  pointer-events: none
  transform: rotate(45deg)

</style>